var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "contact-distributions-by-channel",
      class: { fullscreen: _vm.fullScreen },
    },
    [
      _c("div", { staticClass: "toolbar" }, [
        _c("div", { staticClass: "left" }, [
          _c(
            "div",
            { staticClass: "buttons" },
            [
              _c(
                "IconButton",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: { content: _vm.$t("chart.chartView") },
                      expression: "{ content: $t('chart.chartView') }",
                    },
                  ],
                  attrs: {
                    classNames: _vm.tableMode ? "" : "selected",
                    onClick: function () {
                      return (_vm.tableMode = false)
                    },
                  },
                },
                [_c("md-icon", [_vm._v("insights")])],
                1
              ),
              _vm._v(" "),
              _c(
                "IconButton",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: { content: _vm.$t("chart.tableView") },
                      expression: "{ content: $t('chart.tableView') }",
                    },
                  ],
                  attrs: {
                    classNames: _vm.tableMode ? "selected" : "",
                    onClick: function () {
                      return (_vm.tableMode = true)
                    },
                  },
                },
                [_c("md-icon", [_vm._v("table_view")])],
                1
              ),
              _vm._v(" "),
              _c(
                "IconButton",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: { content: _vm.$t("chart.download") },
                      expression: "{ content: $t('chart.download') }",
                    },
                  ],
                  attrs: { onClick: _vm.exportToExcel },
                },
                [_c("md-icon", [_vm._v("download")])],
                1
              ),
              _vm._v(" "),
              _c(
                "IconButton",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: { content: _vm.$t("chart.fullScreen") },
                      expression: "{ content: $t('chart.fullScreen') }",
                    },
                  ],
                  attrs: { onClick: _vm.switchToFullScreenMode },
                },
                [
                  !_vm.fullScreen
                    ? _c("md-icon", [_vm._v("fullscreen")])
                    : _c("md-icon", [_vm._v("fullscreen_exit")]),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "chart-wrapper" },
        [
          !_vm.tableMode
            ? _c("EChartsHorizontalBar", {
                attrs: {
                  labels: _vm.getLabels(),
                  datasets: _vm.getDatasets(),
                  height: _vm.getChartHeight(),
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.tableMode
            ? _c("TableView", {
                attrs: { cols: _vm.getCols(), rows: _vm.getRows() },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "stats" },
        [
          _c("StatCard", {
            attrs: {
              title: _vm.$t("chart.mostUsedChannel"),
              value: _vm.getStats().maxChannel,
            },
          }),
          _vm._v(" "),
          _c("StatCard", {
            attrs: {
              title: _vm.$t("chart.leastUsedChannel"),
              value: _vm.getStats().minChannel,
            },
          }),
          _vm._v(" "),
          _c("StatCard", {
            attrs: {
              title: _vm.$t("chart.totalPersonCount"),
              value: _vm.formatStat(_vm.getStats().total).value,
              unit: _vm.$t("chart.personsUnit"),
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }